import React, { useContext, useEffect, useState } from 'react';
import { Button } from 'web-store-modules/packages/web-store-ui-library';
import { AddToCartContext } from './AddToCartContext';
import { storeTrans } from '../../../utils/StoreTranslator';
import { ContactButtonClicked } from '../../../utils/Analytics';
import { getStoreId, russiaMKId, spainMKId, polandMKId } from '../../../utils/StoreConfigManager.js';

const storeId = getStoreId();

const CartDropdownFooter = ({ onClick, showSocialIcon, setSocialIcon, showCheckoutIcon, setCheckoutIcon, fontFamilyByStore }) => {
    const {colors, buttonFields} = useContext(AddToCartContext);

    const renderCheckoutText = () => {
        return storeTrans[storeId]['Checkout'];
    }

    const renderYesText = () => {
        return storeTrans[storeId]['Yes'];
    }

    const renderNoText = () => {
        return storeTrans[storeId]['No'];
    }

    const renderWishlistNoText = () => {
        return storeTrans[storeId]['WishlistNoText'];
    }

    return (
        <>
       {([russiaMKId, spainMKId, polandMKId].includes(storeId)) && <div className='wishlist-sharing-heading-consult' style={{...fontFamilyByStore, padding:'0px 20%'}}>
           {storeId !== polandMKId && storeTrans[storeId]['heading4']}
           {storeId === polandMKId && <span><a className="wishlist-consult-link" onClick={() => ContactButtonClicked()} href="https://www.marykay.pl/pl-pl/znajdz-konsultantke-mary-kay" target="_blank">{storeTrans[storeId]['WishlistHeading']}</a></span>}
        </div>}

       { ([russiaMKId, spainMKId, polandMKId].includes(storeId)) && <div className='add-to-cart-menu-button'>
       <Button
            hoverStyleChange={true}
            onClick={setSocialIcon()}
            primaryColor={colors && colors.buyNowPrimaryColor}
            secondaryColor={colors && colors.buyNowSecondaryColor}
            className="product-button flex-center obsessvr-regularFont full-width pointer"
            style={{
                padding: "0px",
                borderRadius: "4px",
                height: "52px",
                backgroundColor: showSocialIcon ? "" : "transparent",
                maxWidth: "120px",
                flex: "0 0 120px",
                display: "flex",
                border: "2px solid #000",
            }}
            primaryBorderColor={colors && colors.buyNowBorderColor}
            secondaryBorderColor={colors && colors.buyNowBorderColor}
            insetBorder={true}
            padded={false}
        >
            <p className='obsessvr-regularFont' style={{
                ...fontFamilyByStore,
                color: showSocialIcon ? "#fff" : "#000"
            }}>
                {renderYesText()}
            </p>
        </Button>

        <Button
            hoverStyleChange={true}
            onClick={setCheckoutIcon()}
            primaryColor={colors && colors.buyNowPrimaryColor}
            secondaryColor={colors && colors.buyNowSecondaryColor}
            className="product-button flex-center obsessvr-regularFont full-width pointer"
            style={{
                padding: "0px",
                borderRadius: "4px",
                height: "52px",
                backgroundColor: showCheckoutIcon ? "" : "transparent",
                maxWidth: "120px",
                flex: "0 0 120px",
                display: "flex",
                border: "2px solid #000",
            }}
            primaryBorderColor={colors && colors.buyNowBorderColor}
            secondaryBorderColor={colors && colors.buyNowBorderColor}
            insetBorder={true}
            padded={false}
        >
            <p className='obsessvr-regularFont' style={{
                ...fontFamilyByStore,
                color: showCheckoutIcon ? "#fff" : "#000"
            }}>
                {renderNoText()}
            </p>
        </Button>
        </div>
        }
        
        {showCheckoutIcon && <>
            <Button
                hoverStyleChange={true}
                onClick={onClick}
                primaryColor={colors && colors.buyNowPrimaryColor}
                secondaryColor={colors && colors.buyNowSecondaryColor}
                className="product-button flex-center obsessvr-regularFont full-width pointer"
                style={{
                    padding: '0', 
                    margin: '15px auto', 
                    width: '280px', 
                    height: '52px',
                    color: "#fff !important"    
                }}
                primaryBorderColor={colors && colors.buyNowBorderColor}
                secondaryBorderColor={colors && colors.buyNowBorderColor}
                insetBorder={true}
                padded={false}
            >
                <p className='obsessvr-regularFont' style={{...fontFamilyByStore}}>
                    {renderCheckoutText()}
                </p>
            </Button>
            {storeId  === spainMKId && <p style={{...fontFamilyByStore, fontSize: '10px', color: '#000', textAlign: 'center', padding: "0px 0 1em", maxWidth: "280px", margin: "10px auto 0"}}>{renderWishlistNoText()}</p>}
        </>}
        </>
    )
}

export default CartDropdownFooter;
